<template>
  <div class="my">
      <Breadcrumb :style="{margin: '14px'}">
          <Icon type="ios-home" class="icon-breadcrumb" />
          <Breadcrumb style="display: inline-block">
              <BreadcrumbItem>账户信息</BreadcrumbItem>
          </Breadcrumb>
      </Breadcrumb>
        <div class="nav">
             <ul>
                 <li :class="{active:isNum==index}" v-for="(item,index) in navList" @click="goPage(item,index)">{{item.name}}</li>
             </ul>
        </div>
        <div class="contint">
            <router-view></router-view>
        </div>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
          navList:[
              {path:'/my',name:'账户信息'},
              {path:'/pass',name:'修改密码'},
              // {path:'/accountGl',name:'账户管理'},
              // {path:'/staffGl',name:'打印设置'},
              {path:'/zhenshi',name:'打印设置'},
              // {path:'/tiaoma',name:'条码打印机纸张选择'},
              {path:'/help',name:'帮助中心',url:'http://www.tangyingchina.com/'},
              {path:'/comein',name:'回收站'},
              {path:'/other',name:'设置'},
          ],
          isNum:0
      }
    },
    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {

      });
    },
    created: function() {
      //DOM更新完之前请求数据

    },
    methods: {
        goPage:function (item,i) {
            if(item.path=='/help'){
                window.open(item.url, '_blank');
            }else {
                this.isNum=i
                this.$router.push({
                    path:item.path
                })
            }
        }
    }
  }
</script>


<style  lang="scss" scoped>
.my{
   height: 100%;
    padding-top: 20px;
    .nav{
        width: 360px;
        height: 100%;
        float: left;
        background:rgba(255,255,255,1);
        border:1px solid rgba(230,230,230,1);
        ul{
            li{
                height: 60px;
                line-height: 60px;
                padding-left: 40px;
                font-size: 16px;
                color:rgba(51,51,51,1);
                cursor: pointer;

            }
            .active{
                color:rgba(83,129,244,1);
            }
        }
    }
    .contint{
        width: auto;
        height: 100%;
        background: #ffffff;
        margin-left: 380px;
        border:1px solid rgba(230,230,230,1);
    }
}

</style>